export default {
   
    finalizado: {
        estado : true
    }
}